import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  ViewChild,
  output,
} from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { BoxComponent, HeadingComponent, IconComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-more-placements-toggle',
  templateUrl: './more-placements-toggle.component.html',
  styleUrls: ['./more-placements-toggle.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslatePipe, HeadingComponent, BoxComponent],
})
export class MorePlacementsToggleComponent {
  public remainingPlacementCount = input.required();
  public showMore = signal(false);

  public valueChange = output<boolean>();

  @ViewChild(BoxComponent, { read: BoxComponent })
  public rtBox: BoxComponent;

  public toggle(): void {
    this.showMore.set(!this.showMore());
    this.valueChange.emit(this.showMore());
  }
}
